import React, { useState, useEffect } from 'react';
import './CardDashboard.css';
import XClose from './x.svg';
import { useStore } from '../../store/useStore';
import site from '../../img/site.svg';
import churned from '../../img/churned.svg';
import totalRacks from '../../img/totalracks.svg';
import added from '../../img/added.svg';
import Noracks from './rafiki.svg';

const CardDashboard = (props) => {
    const { dashData } = useStore()
    const [localVar, setLocalVar] = useState(dashData);

    useEffect(() => {
        setLocalVar(dashData)
    }, [dashData])
    
    return (
        <div className='card-dashboard'>
            <div className='card-dashboard-contaner'>
                <div className='card-dashboard-header'>
                    <h2>{props.siteName}</h2>
                    <img src={site} alt="site" style={{width:"24px", marginLeft:"8px"}}/>
                    <div className='card-dashboard-header-close'>
                        <img src={XClose} onClick={props.close} alt="icone botão fechar card"/>
                    </div>
                </div>

                <div className='card-dashboard-body'>
                    <section>
                        {
                            Object.keys(localVar).map((siteKey, i) => {
                                if(siteKey == props.siteName) {
                                    return (
                                        <section key={i} className="dash-container">
                                            <h2>{Object.keys(localVar[siteKey].counts).length} Salas {!!localVar[siteKey].totalRacks && `| ${localVar[siteKey].totalRacks} Occupied Racks`}</h2>
                                            <div className="dash-list-body">
                                                {
                                                    Object.values(localVar[siteKey].counts).map((count) => {
    
                                                        return (
                                                            <div className="dash-list-item">
                                                                <div className="dash-list-item-header">
                                                                    <h2>Room {count.roomInfo.room}</h2>
                                                                    <h5>Total Racks <b>{count.roomInfo.total}</b></h5>
                                                                    <h5>Total Occupied Now <b>{count.roomInfo.totalRacks}</b></h5>
                                                                    <h5>Projected Racks <b>{count.roomInfo.projectedRacks}</b></h5>
                                                                </div>
                                                                <table className="dash-list-item-body">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Month</th>
                                                                            <th><div>Added<img src={added} alt="added" /></div></th>
                                                                            <th><div>Churned<img src={churned} alt="churned" /></div></th>
                                                                            <th><div>Total<img src={totalRacks} alt="total racks" /></div></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            Object.keys(count.data).reverse().map(val => {
                                                                                return (
                                                                                    <tr>
                                                                                        <td><div>{new Date(val).toLocaleDateString('en-us', { month: 'long', year: 'numeric' })}</div></td>
                                                                                        <td> {count.data[val].added} Racks</td>
                                                                                        <td> {count.data[val].churned} Racks</td>
                                                                                        <td>{count.data[val].total} Racks</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </section>
                                    )
                                } else {<></>}
                                
                            })
                        }
                    </section>
                </div>
            </div>
        </div>
    )
}

export default CardDashboard